import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface CategorySuccessData {
  message: string;
  categoryId: number | string;
}

@Component({
  selector: 'app-category-success-dialog',
  templateUrl: './category-success-dialog.component.html',
  styleUrls: ['./category-success-dialog.component.css'],
  standalone: false,
})
export class CategorySuccessDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CategorySuccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CategorySuccessData
  ) {}

  onFinishSetup(): void {
    this.dialogRef.close('finish');
  }

  onSetupReports(): void {
    this.dialogRef.close('reports');
  }
}

